export default "__VITE_ASSET__BH00vJru__"